import { render, staticRenderFns } from "./c2c.vue?vue&type=template&id=a9296816&"
import script from "./c2c.vue?vue&type=script&lang=js&"
export * from "./c2c.vue?vue&type=script&lang=js&"
import style0 from "./c2c.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports